export const CLearningData = {
    AbsentTimes: "",
    ActiveStatus: "",
    CompletedAsString: "",
    CompletedPercent: 0,
    CreationDate: "",
    CreationTime: "",
    GlobalAbsenceRateAsString: "",
    GlobalAbsenceRateInPercent: 0,
    LearningTimes: "",
    LessonUnits: "",
    MissedEcampusLoginTime: "",
    MissedTimeFromPreviousMonth: "",
    OfferEndDate: "",
    OfferStartDate: "",
    OfferTitel: "",
    OfferUuid: "",
    PeriodEnd: "",
    PeriodStart: "",
    SystemTimes: "",
    TimeCredit: "",
    TimeCreditColor: "",
    TimeCreditInMinutes: "",
    TimeStamp: "",
    TotalAbsenceTime: ""
}